import script from "./BuyingZoneAvailability.vue?vue&type=script&lang=js"
export * from "./BuyingZoneAvailability.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__